export class TeacherContentType {
  id: number;
  description: string;
}
